import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

import { normalText } from 'features/Theme';

export default {
  body: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
    text-align: left;
    margin-bottom: ${theme.mui.spacing(1)}px;

    p {
      margin-bottom: ${theme.mui.spacing(2)}px;
    }
  `,
};
